export default __webpack_public_path__ + "static/media/shots-certificates-icon.dfe64708.svg";